module.exports = __webpack_public_path__ + "media/slider/WelcomeToComposzMobile-89eb6b55.jpg";